import './App.css';
import * as React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import Container from 'react-bootstrap/Container';
import Toast from 'react-bootstrap/Toast';
import ToastBody from 'react-bootstrap/ToastBody';
import { AuthProvider } from './contexts/AuthContext';
import { LandingPage } from './pages/Landing';
import { LoginPage } from './pages/Login';
import { RegistrationPage } from './pages/Register';
// import { DashboardPage } from './pages/Dashboard';
import { NotFound } from './pages/NotFound';
import { CredentialsPage } from './pages/Credentials';
import { DocumentationPage } from './pages/Documentation';
// import { SandboxPage } from './pages/Sandbox';
import { ConfirmEmailPage } from './pages/ConfirmEmail';
import { Login2faPage } from './pages/Login2fa';
import { ResetPasswordPage } from './pages/ResetPassword';

const App = () => {
  const [apiError, setApiError] = React.useState(false);
  const [showToast, setShowToast] = React.useState(false);
  const [toastMessage, setToastMessage] = React.useState("");

  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <Header />
          <Container className="flex-grow-1" fluid="lg">
            <div 
              aria-live="polite" 
              aria-atomic="true" 
            >
              <Toast 
                onClose={() => setShowToast(false)} 
                show={showToast} 
                delay={6000}
                autohide 
                className="position-absolute my-4"
              >
                {apiError === true ? 
                  <ToastBody className="toast-error text-dark">{toastMessage}</ToastBody>
                  :
                  <ToastBody className="toast-info text-dark">{toastMessage}</ToastBody>
                }
              </Toast>
            </div>
            <Switch>
              <Route exact path="/" 
                render={(props:any) => (
                  <LandingPage 
                    {...props} 
                    showToast={setShowToast} 
                    toastMessage={setToastMessage} 
                    apiError={setApiError} 
                  />
                )} 
              />
              <Route exact path="/confirm-email" 
                render={(props:any) => ( 
                  <ConfirmEmailPage 
                    {...props} 
                    showToast={setShowToast} 
                    toastMessage={setToastMessage} 
                    apiError={setApiError} 
                  />
                )} 
              />
              <Route exact path="/login" 
                render={(props:any) => (
                  <LoginPage 
                    {...props}
                    showToast={setShowToast}
                    toastMessage={setToastMessage}
                    apiError={setApiError} 
                  />
                )}
              />
              <Route path="/login2fa" 
                render={(props:any) => (
                  <Login2faPage 
                    {...props}
                    showToast={setShowToast}
                    toastMessage={setToastMessage}
                    apiError={setApiError} 
                  />
                )}
              />
              <Route exact path="/register" 
                render={(props:any) => ( 
                  <RegistrationPage 
                    {...props} 
                    showToast={setShowToast} 
                    toastMessage={setToastMessage} 
                    apiError={setApiError} 
                  />
                )} 
              />
              <Route exact path="/reset-password" 
                render={(props:any) => ( 
                  <ResetPasswordPage 
                    {...props} 
                    showToast={setShowToast} 
                    toastMessage={setToastMessage} 
                    apiError={setApiError} 
                  />
                )} 
              />
              <Route exact path="/credentials"
                render={(props:any) => (
                  <CredentialsPage 
                    {...props}
                    showToast={setShowToast}
                    toastMessage={setToastMessage}
                    apiError={setApiError} 
                  />
                )}
              />
              <Route exact path="/documentation" 
                render={(props:any) => (
                  <DocumentationPage 
                    {...props}
                    showToast={setShowToast}
                    toastMessage={setToastMessage}
                    apiError={setApiError} 
                  />
                )}
              />
              {/* <ProtectedRoute exact path="/sandbox"
                component={SandboxPage}
                apiError={setApiError}
                showToast={setShowToast}
                toastMessage={setToastMessage}
              /> */}
              <Route component={NotFound} />
            </Switch>
          </Container>
          <Footer />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
};

export default App;